/**
 * Phase 0 runs exactly one flow:
 *
 *   add a child → assessment profiling → review the answers → report →
 *   plan (after a focus prompt) or payment
 *
 * The other entry points — the "has this child been assessed before?" triage,
 * the concerns-only guidance route, and browsing the programme on its own —
 * still exist in the code and on the API. They are hidden rather than deleted,
 * so turning them back on is a flag, not a rewrite.
 *
 * Set VITE_SINGLE_FLOW=false to show them again.
 */
export const SINGLE_FLOW = (import.meta.env?.VITE_SINGLE_FLOW as string | undefined) !== 'false';

/**
 * What the intake is answered with when the triage is hidden. 'no' takes the
 * full developmental check with no parent-visible note attached; 'unsure' would
 * print "Not sure whether X was tested before?" to a parent who was never asked.
 */
export const SINGLE_FLOW_PRIOR_TESTING = 'no' as const;
